import JSX from "./react.js";

$('html')
    //Ripple effect
    .on('click', '.main-button,.materiable,.accordion-item', function (this: HTMLElement, e) {
        if ($(this).hasClass('blocked')) return;
        return createElementFromClick.call(this, e!.clientX, e!.clientY);
    })
// .on('touchend', '.main-button,.materiable,.accordion-item', function (this: HTMLElement, e){
//     return createElementFromClick.call(this, e.originalEvent!.changedTouches[0]!.clientX, e.originalEvent!.changedTouches[0]!.clientY);
// })

async function createElementFromClick(this: HTMLElement, touchX: number, touchY: number) {
    const thisWidth = this.clientWidth, thisHeight = this.clientHeight,
        borderRadius = $(this).css('border-radius');
    const diameter = Math.max(thisWidth, thisHeight);
    const radius = diameter / 2;
    const left = (touchX - $(this).offset()!.left! - radius);
    const top = (touchY - $(this).offset()!.top! - radius + window.scrollY);
    return createRipple(thisWidth, thisHeight, borderRadius, diameter, left, top, $(this));

}

async function createRipple(thisWidth: number, thisHeight: number, borderRadius: string, diameter: number, left: number, top: number, appendTo: JQuery) {
    await new Promise(r => setTimeout(r, 10));
    $('.material-ripple,.material-ripple-wrapper').remove();

    const circle = $(
        <span className="material-ripple-wrapper" style={{
            width: thisWidth + "px",
            height: thisHeight + "px",
            borderRadius: borderRadius
        }}>
            <span className="material-ripple" style={{
                width: diameter + 'px',
                height: diameter + 'px',
                left: left + "px",
                top: top + "px",
                cursor: appendTo.css("cursor")
            }}/>
        </span>
    )
        .appendTo(appendTo)
    $(document).one('mousedown touchstart', () => void circle.remove())
    await new Promise(r => setTimeout(r, 600));
    circle.remove();
}
